<div class="form-field"
     [class.error]="isError()"
>
  <div *ngIf="label" [ngClass]="{disabled: control.disabled}" class="label default">
    <div>{{label}} <span class="optional" *ngIf="optional">(optional)</span></div>
    <div class="symbols-left-counter" *ngIf="symbolsLeftCounter">{{value?.length || 0}}/{{maxLength}}</div>
  </div>

  <div class="input-container">
    <textarea class="textarea" [style.height.px]="height"
      #textarea
      [(ngModel)]="value"
      [placeholder]="placeholder"
      [maxlength]="maxLength"
      (ngModelChange)="valueChanged.emit($event)"
      (keydown.Tab)="onTabKeyDown($event)"
    ></textarea>

    <img class="suffix-icon !top-[7%]" *ngIf="isError()" src="assets/icons/icon-field-error.svg" alt="icon-field-error"/>
  </div>
</div>
